import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import ProductItem from '../Category/ProductItem';
import Pagination from '../../hocs/Pagination/Pagination';
import { searchInput, goToPage, retrieveProductCache } from '../../actions/environment';
import { translate, prefix, urlify } from '../../utils/string';
import { unique, intersect } from '../../utils/array';
import s from './Search.scss';

class Search extends Component {
	constructor(props) {
		super(props);

		this.debounceTimer = false;
	}

	componentDidMount() {
		if (this.searchForm) this.searchForm.querySelector('input').focus();
	}

	searchHandler = (e) => {
		e.preventDefault();
	};

	triggerSearchEvent = (value) => {
		if (typeof window !== 'undefined') {
			if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
			if (value.length > 3) {
				window.dataLayer.push({
					event: 'Search',
					values: {
						language: this.props.setup.language,
						search_string: value.toLowerCase(),
					},
				});
			}
		}
	};

	onSearchInputChange = (id, value) => {
		this.props.searchInput(value);
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => {
			this.triggerSearchEvent(value);
		}, 300);
		if (typeof window !== 'undefined') window.history.replaceState({}, '', prefix(this.props.setup, `search${value.length > 0 ? '?' : ''}${value.toLowerCase().replace(' ', '+')}`));
	};

	clearTextHandler = (e) => {
		e.preventDefault();
		const { searchInputText = '', setup, location } = this.props;
		if (searchInputText === '') {
			const searchReturn = location.prev && location.prev.type !== 'SEARCH' && location.prev.pathname ? location.prev.pathname : '/';
			this.props.goToPage(searchReturn.replace(prefix(setup, ''), ''));
		} else {
			this.props.searchInput('');
		}
	};

	addSuggestion = (e) => {
		e.preventDefault();
		const value = e.currentTarget.text;
		this.props.searchInput(value);
		this.triggerSearchEvent(value);
		if (typeof window !== 'undefined') window.history.replaceState({}, '', prefix(this.props.setup, `search${value.length > 0 ? '?' : ''}${value.toLowerCase().replace(' ', '+')}`));
	};

	render() {
		const { setup, searchInputText = '', productCache } = this.props;
		if (!productCache) return null;
		if (!productCache[setup.market] || !productCache[setup.market][setup.pricelist]) {
			this.props.retrieveProductCache();
			return null;
		}

		const suggestions = translate(setup, 'suggestionExamples');
		const filtering = productCache[setup.market][setup.pricelist];
		const searchTerms = filtering.searchTerms[setup.language];
		let productList = [];

		if (searchInputText !== '') {
			searchInputText.split(' ').forEach((wordPart, i) => {
				if (wordPart === '') return;
				let currentSearchMatch = [];

				Object.keys(searchTerms).forEach((term) => {
					const wordPartIndex = term.toLowerCase().indexOf(wordPart.toLowerCase());
					let specificity = 1;

					if (wordPartIndex !== -1) {
						specificity = 1 / searchTerms[term].length; // More products per key = less specific
						specificity = specificity * 100 * (wordPartIndex === 0 ? 10 : 1);

						currentSearchMatch.push({ term, specificity, products: searchTerms[term] });
					}
				});

				if (currentSearchMatch.length === 0) return;

				currentSearchMatch.sort((a, b) => a.specificity - b.specificity);
				currentSearchMatch = currentSearchMatch.reduce((acc, product) => [...acc, ...product.products], []);
				currentSearchMatch = unique(currentSearchMatch);

				productList = i === 0 ? [...currentSearchMatch] : intersect(productList, currentSearchMatch);
			});

			if (typeof window !== 'undefined') window.history.replaceState({}, '', prefix(setup, `search?${searchInputText.toLowerCase().replace(' ', '+')}`));
		}

		productList = productList.sort((a, b) => {
			if (!filtering.products[a] || !filtering.products[b]) return -1;
			return filtering.products[a].added < filtering.products[b].added ? 1 : -1;
		});

		return (
			<div className={s.search}>
				<form className={s.search_form} ref={(form) => { this.searchForm = form; }} onSubmit={this.searchHandler}>
					<Input id="search" type="text" value={searchInputText} placeholder={translate(setup, 'search')} inputChange={this.onSearchInputChange} />
					<a className={s.search_form_clear} href="#clearText" onClick={this.clearTextHandler}>
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
							<g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="square" strokeWidth="1.3" transform="translate(1 1)">
								<path d="M0.405,0.409090909 L15.795,17.5909091" />
								<path d="M0.405,0.409090909 L15.795,17.5909091" transform="matrix(-1 0 0 1 16.2 0)" />
							</g>
						</svg>
					</a>
					<button className={s.search_form_submit} type="submit" />
				</form>
				<div className={s.search_suggestions}>
					<span className={s.search_suggestions_title}>{ translate(setup, 'suggestions') }</span>
					<div className={s.search_suggestions_links}>
						{
							suggestions ? suggestions.split('\n').map((suggestion) => (
								<a key={urlify(suggestion)} className={s.search_suggestions_links_link} onClick={this.addSuggestion} href="#suggestion"><span className="a-searchSuggestion">{ suggestion.replace(/^\s*|\s*$/g, '') }</span></a>
							)) : null
						}
					</div>
				</div>
				<div className={s.search_products}>
					<Pagination ListComponent={ProductItem} list={productList} cache={filtering.products} currentPath="search" canonical />
				</div>
			</div>
		);
	}
}

const mapState = ({ environment, location, productCache, filtering }) => ({
	setup: environment.setup,
	searchInputText: environment.searchInputText,
	location,
	productCache,
	filtering,
});

export default hot(module)(connect(mapState, { searchInput, goToPage, retrieveProductCache })(Search));
